import { useEffect } from "react";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import ProblemSection from "@/components/site/ProblemSection";
import OutcomeSection from "@/components/site/OutcomeSection";
import MethodSection from "@/components/site/MethodSection";
import ServicesSection from "@/components/site/ServicesSection";
import ImpactSection from "@/components/site/ImpactSection";
import ROICalculator from "@/components/site/ROICalculator";
import WhyUsSection from "@/components/site/WhyUsSection";
import DontDoSection from "@/components/site/DontDoSection";
import { CaseStudiesSection, LighthouseSection } from "@/components/site/CaseLighthouse";
import FAQSection from "@/components/site/FAQSection";
import LeadFormSection from "@/components/site/LeadFormSection";
import Footer from "@/components/site/Footer";
import { captureUtm } from "@/lib/utm";

export default function Home() {
  useEffect(() => {
    captureUtm();
  }, []);

  return (
    <div className="bg-brand-cream">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <ProblemSection />
        <OutcomeSection />
        <MethodSection />
        <ServicesSection />
        <ImpactSection />
        <ROICalculator />
        <WhyUsSection />
        <DontDoSection />
        <CaseStudiesSection />
        <LighthouseSection />
        <FAQSection />
        <LeadFormSection />
      </main>
      <Footer />
    </div>
  );
}
